import type { AssetsConfigAllAtlassianArgs, AssetsConfigPreloadedArgs } from "@atlaskit/react-ufo/common";

const allAtlassian = ({ entry }: AssetsConfigAllAtlassianArgs): boolean => {
  const isAtlassian =
    entry.name.includes("atlaskit") ||
    entry.name.includes("atlassian") ||
    entry.name.includes("atl-pass.net/") ||
    (entry.name.includes("cloudfront") && entry.name.includes("batch.js"));
  return isAtlassian;
};

const preloaded = ({ entry, SSRDoneTime }: AssetsConfigPreloadedArgs): boolean => {
  return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};

export const assetsConfig = {
  allowedTypes: ["js", "css"],
  classification: {
    all: true,
    allAtlassian,
    preloaded,
  },
};
